import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import router from './router/router';
import { getrealRouter, getSiderbar, getUserProductList } from './utils/fliter-pression';

import { deepCopy } from './utils/formate';
// import mockPression from './mock/pression';
import { allRouter } from './router/dynamic-router';

import auth from '@/api/auth';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage,
});
const localState = {
    realRouter: [],
    siderData: [],
    user: '',
    product: [],
};
const copyState = deepCopy(localState);

export default new Vuex.Store({
    state: {
        realRouter: [],
        siderData: [],
        user: '',
        product: [],
    },
    mutations: {
        setRouter(s:any, data:any) {
            s.realRouter = data;
        },
        setSider(state:any, data:any) {
            state.siderData = data;
        },
        setUser(User:any, data:any) {
            User.user = data;
        },
        setProduct(Product:any, data:any) {
            Product.product = data;
        },
        resetState(states:any) {
            Object.keys(states).forEach((d:any) => {
                states[d] = copyState[d];
            });
        },
    },
    actions: {
    // 获取用户权限  向后端发送请求 todo
    // 模拟数据
        GETPRESSION({ commit }, pression:any) {
            const mockPression:any = [];
            let routers:Object[] = [];
            routers = getrealRouter(pression, allRouter);
            const base:any = [{
                path: '/base',
                name: 'base',
                component: () => import('@/views/base.vue'),
            }];
            // 优化，新增默认页面“”
            base[0].children = routers;
            router.addRoutes(base);
            // 将当前所有路由存入store；
            this.commit('setRouter', routers);
            const list = getUserProductList(routers);
            this.commit('setProduct', list);
            return routers;
        },
        // 获取当前产品的侧边栏产品
        GETSIDER({ commit }, nowProdcut:string) {
            /**
             * nowProdcut当前产品 ， sideData产品下侧边的内容
             */
            const all = this.state.realRouter;
            let sider:any[] = [];
            sider = getSiderbar(all, nowProdcut);
            console.log(sider);
            this.commit('setSider', sider);
            return sider;
        },

    },
    plugins: [vuexLocal.plugin],
});
